// extracted by mini-css-extract-plugin
module.exports = {"infocon":"eYVvH","text":"pBxcP"};